import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import IconSpinner from '../../img/spinner.gif';
import Dialog from './Dialog';
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../store/modules/dialog';
import axios from 'axios';
import { usePOWebofficeSDKState } from '../../context/poWebOfficeSDKContext';
import { useDocInfoSliceSelector } from '../../store/modules/docInfo';
import { downloadFileWithBlob } from '../../utils/FileControlUtil';
import { saveFile, useIndexedDBDispatch, useIndexedDBState } from '../../context/indexedDBContext';
import { useGenConfirmPromise } from '../confirm/Confirm';
import { useOpenCurrentTab, useOpenNewTabWithQueryinSameDomain } from '../../utils/util';
import { QS_CONSTANT } from '../../define/global';
import moment from 'moment';

const DialogBody = styled.div`
  display: flex;
  flex-flow: column;
  width: 300px;
  height: 200px;
  justify-content: center;
  align-items: center;
`;

const TitleMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SpinnerIcon = styled.img`
  width: 64px;
  height: 64px;
`;

export default function TranslateDialog({ isShow }) {
  const dispatch = useDispatch();
  const poSDKContextState = usePOWebofficeSDKState();
  const docInfoSlice = useDocInfoSliceSelector();
  const indexedDBState = useIndexedDBState();
  const indexedDBDispatch = useIndexedDBDispatch();
  const confirmPromise = useGenConfirmPromise();
  const openCurrentTab = useOpenCurrentTab();
  const openNewTabWithQueryinSameDomain = useOpenNewTabWithQueryinSameDomain();
  const [error, setError] = useState(false);
  const { i18n } = useTranslation();
  const [targetlangString, setTargetlangString] = useState(
   ""
  );

  const openTranslateDocument = async () => {
    const poSDKReady = poSDKContextState.poInstance !== null;
    if (poSDKReady) {
      try {
        const savedFile = await poSDKContextState.poInstance.handle.saveDocument();

        const bodyFormData = new FormData();
        bodyFormData.append('input', new File([savedFile.blob], docInfoSlice.fileName));

        const serviceDomain = 'http://service.llsollu.io:8903';

        let detectedLangCode = 'ko';
        try {
          const detectedRes = await axios.post(
            serviceDomain +
              '/nlp/lid/detectLanguage/document?key=4ac4cb0e-7e13-4166-b646-984e06d26ec2',
            bodyFormData,
            {
              headers: { 'Content-Type': 'multipart/form-data' }
            }
          );

          detectedLangCode = detectedRes.data.detectedLanguages[0].lang;
        } catch (err) {}

        const targetLangCode = detectedLangCode === 'ko' ? 'en' : 'ko';

        setTargetlangString(
          targetLangCode === 'ko'
            ? i18n.t('TranslateDialog.translatingTargetKo')
            : i18n.t('TranslateDialog.translatingTargetEn')
        );

        const res = await axios.post(
          serviceDomain +
            `/translation/file/translate?key=4ac4cb0e-7e13-4166-b646-984e06d26ec2&target=${targetLangCode}`,
          bodyFormData,
          {
            responseType: 'blob',
            headers: { 'Content-Type': 'multipart/form-data' }
          }
        );

        const newName =
          `translated_${moment().format('YYYY-MM-DD HHmmss')}_` + docInfoSlice.fileName;

        const file = new File([res.data], newName, {
          type: 'application/x-hwp'
        });

        const openNewTab = (startMode) => {
          openNewTabWithQueryinSameDomain(startMode);
        };

        await saveFile({ state: indexedDBState, dispatch: indexedDBDispatch, file });
        if (indexedDBState.status === 'unsupported') {
          const confirm = await confirmPromise({
            title: i18n.t('Common.Notification'),
            message: i18n.t('Common.OpenCurrentTabWarning'),
            btn: {
              confirm: {
                text: i18n.t('Common.Confirm')
              },
              cancel: {
                text: i18n.t('Common.Cancel')
              }
            }
          });
          if (confirm) {
            openCurrentTab(file, (executeTime, fileBlob) => {});
          }
        } else {
          openNewTab(QS_CONSTANT.START_MODE.VALUES.OPEN_MOST_RECENT_DOC);
        }
        dispatch(closeDialog());
      } catch (error) {
        setError(true);
      } finally {
      }
    }
  };

  useEffect(() => {
    openTranslateDocument();
  }, []);

  return (
    <Dialog
      isShow={isShow}
      showCloseBtn={error}
      onClickCloseBtn={() => {
        dispatch(closeDialog());
      }}
      title={i18n.t('TranslateDialog.title')}>
      <DialogBody>
        {error === false ? (
          <>
            <TitleMessage>
              {i18n.t('TranslateDialog.translating', {
                lang: targetlangString
              })}
            </TitleMessage>
            <SpinnerIcon src={IconSpinner} />
          </>
        ) : (
          <TitleMessage>{i18n.t('TranslateDialog.translateFail')}</TitleMessage>
        )}
      </DialogBody>
    </Dialog>
  );
}
